
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

declare global {
    interface Window {
        Pusher: typeof Pusher;
        Echo: Echo;
    }
}

window.Pusher = Pusher;

import { LocalStorageKeys } from '@/constants/LocalStorageKey.constant';

// Build auth headers with dynamic getters so the current token
// and school ID are read from localStorage at each auth request,
// not captured once at module init time.
const authHeaders: Record<string, string> = {
  'Apollo-Require-Preflight': 'true',
};

Object.defineProperty(authHeaders, 'Authorization', {
  get: () => `Bearer ${localStorage.getItem(LocalStorageKeys.token)}`,
  enumerable: true,
});

Object.defineProperty(authHeaders, 'X-Current-School-ID', {
  get: () => localStorage.getItem(LocalStorageKeys.currentSchoolId) ?? '',
  enumerable: true,
});

const echo = new Echo({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
  wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
  enabledTransports: ['ws', 'wss'],
  disableStats: true,
  authEndpoint: (import.meta.env.VITE_BACKEND_API_URL as string)?.replace(/\/graphql\/?$/, '') + 'graphql/subscriptions/auth',
  auth: {
    headers: authHeaders,
  },
});

export default echo;
